//react...
import React from "react";

import "./Examinations.styles.css";

const AliGhafouri = () => {
  return (
    <div className="examination-container">
      <div className="box">
        <div className="name"> Mr. Ali Ghafouri </div>

        <div className="score"> score: 90 / 100 </div>
      </div>
    </div>
  );
};

export default AliGhafouri;
